import aftershootCoin from "./aftershoot-coin.svg";
import aftershootOutlineLogo from "./aftershoot-outline-logo.svg";
import aftershootBlueLogoOutline from "./aftershootBlueLogoOutline.svg";
import aftershootBlueLogo from "./aftershootbluelogo.svg";

import cullingColorIcon from "./culling-color-icon.svg";
import editingColorIcon from "./edit-color-icon.svg";
import retouchColorIcon from "./retouch-color-icon.svg";

import aiCullBg from "./ai-cull-bg.webp";
import aiEditBg from "./ai-edit-bg.webp";
import arrowDown from "./arrow-down.svg";
import captureOneLogo from "./capture-one.webp";
import celebrateIcon from "./celebrate-img.webp";
import checkRoundGreen from "./check-round-green.svg";
import competitorIcon from "./competitor.svg";
import conelogo from "./conelogo.svg";
import congratsIcon from "./congrats.webp";
import crossRoundRed from "./cross-round-red.svg";
import cullingGetStartedImg from "./cullinggetstarted.webp";
import cullingPreferenceImg from "./cullingpreferences.webp";
import cullingSprayImg from "./cullingspray.webp";
import cullingWarningImg from "./cullingwarning.webp";
import cullingWorkflowImg from "./cullingworkflow.webp";
import digitalCameraWorld from "./digitalcameraworldlogo.svg";
import editWithAftershootImg from "./editwithaftershoot.webp";
import facebook from "./facebookWhite.svg";
import introToEditsImg from "./introtoedits.webp";
import invertedApotrophe from "./inverted-apostrophe.svg";
import lightroomLogo from "./lightroom.svg";
import loadingIcon from "./loading-svg.svg";
import aftershootTitle from "./logo-aftershoot-dark.svg";
import aftershootTitleLight from "./logo-aftershoot-light.svg";
import aftershootLogo from "./logo.svg";
import logoGif from "./logo_light.gif";
import LoadingGif from "./logo_no_background_compressed.gif";
import lrclogo from "./lrclogo.svg";
import nphoto from "./nphoto.svg";
import pentapixel from "./pentapixel.svg";
import photofocus from "./photofocus.svg";
import photonLogoWhite from "./photon-logo-white.png";
import photographyLogo from "./photographylogo.svg";
import shotKit from "./shotkit.svg";
import testimonial1 from "./testimonial1.webp";
import testimonial2 from "./testimonial2.webp";
import testimonial3 from "./testimonial3.webp";

export const loadingGif = LoadingGif;

const sharedAssets = {
  aftershootOutlineLogo,
  conelogo,
  lrclogo,
  aftershootBlueLogoOutline,
  congratsIcon,
  celebrateIcon,
  aftershootBlueLogo,
  aftershootLogo,
  aftershootTitle,
  aftershootTitleLight,
  captureOneLogo,
  digitalCameraWorld,
  lightroomLogo,
  cullingGetStartedImg,
  cullingPreferenceImg,
  editWithAftershootImg,
  cullingSprayImg,
  facebook,
  cullingWorkflowImg,
  introToEditsImg,
  cullingWarningImg,
  nphoto,
  pentapixel,
  photofocus,
  photographyLogo,
  photonLogoWhite,
  shotKit,
  testimonial1,
  testimonial2,
  testimonial3,
  aiCullBg,
  aiEditBg,
  competitorIcon,
  invertedApotrophe,
  arrowDown,
  aftershootCoin,
  crossRoundRed,
  checkRoundGreen,
};

export {
  aftershootLogo,
  aftershootTitle,
  aftershootTitleLight,
  celebrateIcon,
  checkRoundGreen,
  congratsIcon,
  crossRoundRed,
  cullingColorIcon,
  editingColorIcon,
  loadingIcon,
  logoGif,
  photonLogoWhite,
  retouchColorIcon,
};

export default sharedAssets;
